import { api } from "@/api";
import { sleep } from "@/shared/utils";

export async function getImage(id: string): Promise<File | undefined> {
    try {
        await sleep(500);
        const response = await api.get("articulos/" + id + "/image", { responseType: "blob" });
        if (!response.data) return undefined;
        const blob: Blob = response.data;
        if (blob.size <= 0) return undefined;
        return new File([blob], `articulo/${id}/${blob.type}`, { type: blob.type });
    } catch {
        return undefined;
    }
}
